<template>
    <div class="content-wrapper full-page-wrapper auth-pages login-2" style="background:#f8f8f8">
        <div class="row h-100">
     <!-- <particles-bg type="random" :bg="true" /> -->
            <div class="col-lg-4 carouselPanel d-none d-sm-none d-md-block text-center pt-3" >
                <transition name="fade">
                  <!-- <img :src="'/images/background/'+baner+'.png'" alt="Slide1" width="600px"><br> -->
                </transition>
            </div>
            <div class="col-lg-4 carouselPanel loginPanel">
                <transition name="fade">
                <div class="card">
                <div class="card-body px-5 py-5 col-lg-12 col-md-12 col-xs-12 model-input">
                    <!--  <div class="text-uppercase" style="margin-top:20px;text-align:left;">
                        <h6 v-if="baner===3">Vos informations sont 100% sécurisées et confidentielles</h6>
                        <h6 v-if="baner===2">Gérer vos opérations depuis une plateforme simple d’utilisation</h6>
                        <h6 v-if="baner===1">Payez, Recevez et envoyez de l’argent partout et à tout moment !</h6>
                    </div> -->
                    <!-- <div class="w-100">
                        <div class=" text-center mt-5">
                            <img v-lazy="'/images/logo_large.png'" alt="logo intram" class="card-image">
                        </div>
                    </div> -->
                    <div class="row">
                              <div class="col-12 text-left pl-0 ml-0 mt-5 pt-5 col-12 mb-0 pb-0">
                        <img src="/images/logo_large_white.png" alt="" width="200px">

                        </div>
                        <h5 class="text-left  mt-2 pt-2 col-12 ">
                         <span style="border-radius:10px;margin-bottom:0px;font-weight:bold"> Connectez-vous  </span>
                            <br>
                            <small>Accédez à votre compte marchand en saisissant vos informations de connexion.</small>
                            </h5>

                    </div>
                    <div style="display:none;margin-top: 25px" id="verif-error" class="alert alert-warning ml-3 mr-3 pt-2 pb-2"></div>
                    <div style="display:none;margin-top: 25px" id="verif-success" class="alert alert-success ml-3 mr-3 pt-2 pb-2"></div>

                    <form class="row" @submit.prevent="submitForm">
                        <transition name="fade">
                            <div id="text-error-box" class="alert alert-warning ml-3 mr-3 pt-2 pb-2" v-show="state==='error'" style="margin: 5px">
                                {{$t(errors.login)}}
                            </div>
                        </transition>

                      <transition name="fade">
                        <div id="text-error-box1" class="alert alert-danger ml-3 mr-3 pt-2 pb-2" v-show="showerror" style="margin: 5px">
                          Une erreur s'est produite
                        </div>
                      </transition>

                        <div class="form-group col-md-12 col-lg-12">
                            <label for="email" class="form-label">Votre adresse Electronique <span class="requiredCheck">*</span></label>
                            <input type="text" id="email" v-model="email" class="form-control p_input"
                                   placeholder="Votre adresse e-mail">
                            <span class="error-box" v-show="errors.email">{{$t(errors.email)}}</span>

                        </div>
                        <div class="form-group col-md-12 col-lg-12 pt-0">
                            <label for="password" class="form-label">Votre mot de passe <span class="requiredCheck">*</span></label>
                            <input type="password" id="password" v-model="password" class="form-control p_input"
                                   placeholder="Votre mot de passe">
                            <span class="error-box" v-show="errors.password">{{$t(errors.password)}}</span>

                        </div>
                        <div class="col-12 pt-0 pb-0 mb-0">
                        <div style="text-align: center" class="col-lg-12 col-xs-12 submit_panel" v-if="submitting && !login">
                            <img style="width: 30px" alt="loader" v-lazy="'/loaders/loader_turq.gif'"/> connexion en cours ...
                        </div>
                       <div style="text-align: center" class="col-lg-12 col-xs-12 redirection_panel" v-if="!submitting && login">
                            <img style="width: 30px" alt="loader" v-lazy="'/loaders/loader_turq.gif'"/> Connexion établis ! Redirection en cours ...
                        </div>
                        </div>
                        <div class="text-center col-lg-12 col-xs-12 pb-0" v-if="!submitting && !login">
                            <button type="submit" class="btn btn-default btn-sm enter-btn">Connectez-vous</button>
                        </div>
                        <div class=" col-lg-12 col-xs-12  text-right pt-0 loginBottom">
                            <router-link to="/password/forget" class="forgot-pass">J'ai oublié mon mot de passe !</router-link>
                            <br>
                        </div>
                         <div class="col-xs-12 col-lg-12 mb-5 pb-5 text-center">
                            <span class="text-center ">Vous n’avez pas de compte? ? <router-link
                                    to="/register" class="connect-btn" style="font-weight:bold; color: #fff!important;"> S'Incrire Maintenant</router-link></span>
                        </div>

                    </form>
                </div>
                </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
    import {mapState} from "vuex";
    import helpers from "../../mixins/helpers";
    import moment from 'moment';
    export default {
        name: "Login",
        mixins:[helpers(this)],
        data() {
            return {
                baner:(Math.floor(Math.random() * 3) + 1),
                submitting: false,
                showerror: false,
                email: null,
                password: null,
                errors: {},
                state: '',
                login:false
            }
        },
        mounted() {
            this.validateAccount();
        },
        computed: {
            ...mapState('auth/', ['verification_errors']),
            ...mapState('generalsettings/',['generals']),

        },
        methods: {

            checkisDashboard() {
                this.$emit('checkisDashboard', false);
            },
            submitForm() {
                let VueBox = this;
                this.validateForm();
                if (!this.canContinue)
                    return;

              let maxAttempts = this.getSetting('nevc');
              let userAttempt = (localStorage.getItem('attempts') && localStorage.getItem('attempts')!=='undefined' && localStorage.getItem('attempts')!=='null')? JSON.parse(localStorage.getItem('attempts')) : undefined;
              if (userAttempt && userAttempt.attempts>=maxAttempts && this.email===userAttempt.email){
                let now = new moment();
                let last_attempt = userAttempt.last_attempt_at;
                let duration = now.diff(new moment(last_attempt),'minutes');
                if (duration<=10){
                  let remainingDuration = 10 - duration ;
                  this.state = 'error';
                  this.errors.login = this.$t('attempts_exceed',{minutes:''+remainingDuration});
                  $('#text-error-box').text(this.$t('attempts_exceed',{minutes:''+remainingDuration}));
                  return ;
                }else {
                  this.state = '';
                  this.errors.login = '';
                  $('#text-error-box').text('');

                }

              }
                this.submitting = true;
                let data = new FormData();
                data.append('email', this.email);
                data.append('password', this.password);
                this.$store.dispatch("auth/login", data).then(response => {
                    this.submitting = false;
                    if (response.error) {
                        VueBox.state = 'error';
                        if (response.attempts){
                            localStorage.setItem('attempts',JSON.stringify(response.attempts));
                            $('#text-error-box').text(VueBox.$t(response.message,{minutes:response.lang_param}));
                        }else{
                            $('#text-error-box').text(VueBox.$t(response.message));
                        }
                    } else {
                        VueBox.login=true;
                        localStorage.removeItem('attempts');
                        location.reload();
                    }
                })
                .catch(error => {
                  this.submitting = false
                  this.showerror = true
                });
            },
            validateForm() {
                this.errors = {};
                if (this.email === null || this.email.trim().length === 0) {
                    this.errors.email = 'email_required';
                }else{
                    if (!this.isValidEmailAddress(this.email)){
                        this.errors.email =  'invalid_email';
                    }
                }
                if (this.password === null || this.password.trim().length === 0) {
                    this.errors.password = 'password_required';
                }

                this.canContinue = Object.keys(this.errors).length === 0;
            },
            resetDatas(component) {
                Object.assign(component.$data, component.$options.data.apply(component))
            },
            validateAccount() {
                let VueBox = this;
                /* eslint-disable */
                if (this.$route.params.token) {
                    this.$store.dispatch('auth/verify', this.$route.params.token).then((response) => {
                        console.log('result', response)
                        let errorBox = (response.error) ? $('#verif-error') : $('#verif-success');
                        errorBox.text(VueBox.$t(response.message));
                        errorBox.fadeIn("slow");
                    });

                }
            }
        },
        created() {
            this.checkisDashboard();

        },

    }

    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }

    const publicVapidKey = 'BI8KnDC_E0DRlZaiCFP9LxxRnlG_rK5GRngZRpgakNhBc1MPAqRVhb1uuw4ttOCLN8-csiYw6qV25fO85o71dXs';
    async function getSub() {
        if ('serviceWorker' in navigator) {
            let register = await navigator.serviceWorker.register('../v-lazy/js/sw.js', {
                scope: '../v-lazy/js/'
            }).catch((error) => {
                // console.error('error',error)
            });

            let subscription = await register.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
            });

            return JSON.stringify(subscription);
        } else {
            return 'Service workers are not supported in this browser';
        }
    }
</script>


<style scoped>
.redirection_panel, .submit_panel {
    color: #fff !important;
}
    .auth-pages .form-group{
        margin-bottom: 5px !important;
    }
    .model-input{
        padding: 0 20px !important;
    }
    .submit_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 10pt;
         color: rgb(31, 23, 23);
        text-transform: uppercase;
    }
    .redirection_panel{
        padding: 5px;
        font-weight: 500;
        font-size: 9pt;
        color: rgb(31, 23, 23);
        text-transform: uppercase;
        border-radius: 6px;
    }
    #countries{
        color: #0D0A0A !important;
    }
    .connect-btn{
        color: #fff;
        font-weight: 500;
        text-decoration: underline;
    }
    .loginPanel .card{
        margin-top: auto;
margin-bottom: auto;
        /*  background-image: linear-gradient(#f8f8f8, #29B3A6);  */
        background-color: #29B3A6;
        box-shadow: 0px 0px 1.875rem rgb(6 71 124 / 17%);
    }
    .card{
        background: transparent;
        box-shadow: none !important;
        border: none !important;
    }
    .loginPanel{
        padding: 20px!important;
        min-height: 100vh;
        display: flex;
  align-items: center;
/* background-image: linear-gradient(#f8f8f8, #29B3A6); */
    }
    .requiredCheck{
        color: red;
    }
    .loginBottom{
        font-size: 12pt;
    }

    #loginCarousel{
        max-height: 100vh;
    }

    .carousel-inner{
        height: 100%;
    }
    .carousel-inner{
        background-size: cover;
        text-align: center;
    }
    .qrPanel{
        color:#fff;
        position: absolute;
        bottom: 70px;
        left: 17vw;
        width: 350px;
        padding: 20px;
        background: rgba(16, 70, 65, 0.8);
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
        border-radius: 23px;
        font-size: 11pt;
        font-weight: bold;
    }
    .qrPanel img{
        width: 250px !important;
    }

    .qrPanel span{
        padding: 20px;
        margin-top: 20px;
        font-size: 11pt;
        font-weight: bold;
        text-transform: uppercase;
        color: #fff;
    }

    .carouselPanel{
        padding: 0;
    }
    .card-image{width: 250px}
    .auth-pages .form-group .form-control{border-radius: 6px;height: 40px;border: 1px solid rgba(0, 0, 0, 0.15);}
    .wrapper{
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .background-3 {
        /*box-shadow: inset 0 0 100px hsla(0,0%,0%,.3);*/
    }
    .form-label{
        font-size: 12pt;
        font-weight: 500;
        color: #fff;
    }

    .auth-pages .form-group .form-control:focus{
        transition-duration: 5ms;
        border: 1px solid rgba(41, 179, 166, 1);
    }
    .auth-pages .form-group .form-control:hover{
        border: 1px solid rgba(41, 179, 166, 1);
        transition-duration: 5ms;
    }
.auth-pages.login-2 .card{
    min-height: unset;
}
    @media (max-width: 991px) {
        .model-input{
            padding: 0 25px !important;
        }
    }
    .carousel-item img{
        width: 100%;
    }
    .carousel-indicators li{
        color:#373737
    }
    canvas{
        min-height: 100vh !important;
        height: auto !important;
    }
    .carouselPanel{
        color: #fff !important;
    }
    .auth-pages button{
        font-size: 1rem;
    }
    .forgot-pass{
       color: #fff !important;
    }
</style>
